"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogCas = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var url_js_1 = require("../variables/url.js");
var espolAds_js_1 = require("../variables/espolAds.js");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var cast = localBack + "api/accounts/pruebanotificacion?ticket=";
var LogCas = /** @class */ (function (_super) {
    __extends(LogCas, _super);
    function LogCas(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { title: "LogCas", ticket: '' };
        // This binding is necessary to make "this" work in the callback  
        //if (sessionStorage.getItem('token') === undefined) {
        /*console.log(this.getQueryVariable("ticket"));*/
        var ticket = _this.getQueryVariable("ticket");
        if (ticket === undefined) {
            _this.props.history.push('/general/principal');
        }
        else {
            /*console.log("tiene tickets");*/
            /*this.prueba(ticket);*/
            fetch(cast + ticket, {
                /*mode: 'no-cors',*/
                method: 'GET'
            }).then(function (response) { return response.json(); }).
                then(function (data) {
                var respuesta = data;
                if (respuesta.token != null) {
                    espolAds_js_1.setCookie('userEspol', respuesta.username, 2);
                    espolAds_js_1.setCookie('token', respuesta.token, 2);
                    espolAds_js_1.setCookie('isAdmin', respuesta.roles.includes("Administrador"), 2);
                    espolAds_js_1.setCookie('isRev', respuesta.roles.includes("Revisor"), 2);
                    espolAds_js_1.setCookie('isCreator', respuesta.roles.includes("Creador"), 2);
                    //if (respuesta.roles.includes("Administrador")) {
                    //    this.props.history.push('/admin/user-admin');
                    //} else if (respuesta.roles.includes("Revisor")) {
                    //    this.props.history.push('/reviewer/aprobar-anuncio');
                    //} else if (respuesta.roles.includes("Creador")) {
                    //    this.props.history.push('/creator/mis-comunicados');
                    //} else {
                    //    this.props.history.push('/general/principal');
                    //}
                    _this.props.history.push('/general/principal');
                }
            }).catch(function (err) {
                alert('Error al iniciar sesión');
            });
        }
        _this.prueba = _this.prueba.bind(_this);
        _this.getQueryVariable = _this.getQueryVariable.bind(_this);
        return _this;
    }
    ;
    LogCas.prototype.prueba = function (ticket) {
        fetch(localBack + "/api/accounts/pruebaNotificacion?ticket=" + ticket)
            .then(function (response) {
            /*console.log(response);*/
        })
            .catch(function (error) {
            /*console.log(error);*/
        });
    };
    ;
    LogCas.prototype.getQueryVariable = function (variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
    };
    ;
    LogCas.prototype.render = function () {
        var contents = React.createElement("div", null,
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardBody, null,
                    React.createElement("div", { className: "loader" }))));
        return React.createElement("div", null,
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, "Bienvenido a EspolAds")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    ;
    return LogCas;
}(React.Component));
exports.LogCas = LogCas;
//# sourceMappingURL=LogCas.js.map